import joi from "joi";
import {cancellationCodes} from "./common";

export const cancelOrderSchema = joi.object({

  code: joi.string().allow(...Object.keys(cancellationCodes)),
  note: joi.string().min(1),

});
